var exports = {
  "kL": "CreateDMBottomSheet.module__container___VS1LeG",
  "XG": "CreateDMBottomSheet.module__scroller___VS1LeG",
  "Qs": "CreateDMBottomSheet.module__content___VS1LeG",
  "h_": "CreateDMBottomSheet.module__description___VS1LeG",
  "ov": "CreateDMBottomSheet.module__friendSelector___VS1LeG",
  "qr": "CreateDMBottomSheet.module__footer___VS1LeG",
  "x7": "CreateDMBottomSheet.module__cancelButton___VS1LeG",
  "Tf": "CreateDMBottomSheet.module__createButton___VS1LeG",
};

module.exports = exports;
